export const defaultLayout = {
  header: 'default',
  footer: 'default'
};